import { render } from "./KpiSectionHeader.vue?vue&type=template&id=e6fad4ea&scoped=true"
import script from "./KpiSectionHeader.vue?vue&type=script&lang=js"
export * from "./KpiSectionHeader.vue?vue&type=script&lang=js"

import "./KpiSectionHeader.vue?vue&type=style&index=0&id=e6fad4ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6fad4ea"]])

export default __exports__